import * as React from "react";
import { Box, Card, CardContent, Typography, Button, Stack } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

const ErrorReservation = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
    >
      <Card sx={{ maxWidth: 420, width: "100%", textAlign: "center", p: 2 }}>
        <CardContent>
          <ErrorOutlineIcon
            color="error"
            sx={{ fontSize: 64, mb: 1 }}
          />

          <Typography variant="h5" gutterBottom>
            No se pudo realizar la reserva
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={3}>
            Ocurrió un error al procesar tu reservación.  
            Por favor, intenta nuevamente o vuelve más tarde.
          </Typography>

          <Stack spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/reservar")}
            >
              Intentar nuevamente
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate("/")}
            >
              Volver al inicio
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ErrorReservation;